<ng-template *ngIf="!popupView" [ngTemplateOutlet]="loginPopup" />

<ng-template #loginPopup>
  <div class="wrap {{theme}}" [class.in-popup]="popupView" [class.inlineLogin]="isInline">
    <div *ngIf="popupView && !showBack" class="close-btn desk-only" (click)="closePopup()"><em class="material-icons">close</em></div>
    <div *ngIf="showBack" class="backBtn" (click)="closeOnBack?closePopup():goBack()"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#262626"><path d="m313-440 196 196q12 12 11.5 28T508-188q-12 11-28 11.5T452-188L188-452q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l264-264q11-11 27.5-11t28.5 11q12 12 12 28.5T508-715L313-520h447q17 0 28.5 11.5T800-480q0 17-11.5 28.5T760-440H313Z"/></svg></div>
    <div class="content">
      <div *ngIf="!isInline && (!showOtpSeparate || !showOtp)" class="head">
        <div class="title" [innerHTML]="title"></div>
      </div>
      <div *ngIf="!isInline && showOtpSeparate && showOtp" class="head">
        <div class="icon"><em class="material-icons">phone</em></div>
        <div class="title">Enter the OTP sent to <br> {{extn}} {{mobileControl?.value}}</div>
      </div>
      <div class="form-section">
        <form *ngIf="userForm" [formGroup]="userForm" (ngSubmit)="onSubmit()">
          <div class="input-fields">
            <div class="field" [class.d-none]="(isInline || showOtpSeparate) && showOtp">
              <div class="mobile" [class.otp-sent]="showOtp">
                <app-phone-number-input-v2 *ngIf="showInputV2"
                  inputId="mobileInput"
                  [theme]="theme"
                  placeHolder="Enter Mobile Number"
                  [label]="inputLabel"
                  [group]="userForm"
                  [control]="mobileControl"
                  [showEdit]="false"
                  (onEditClick)="editMobileClick($event)"
                  (onCountryChange)="setCountry($event)"
                  (onFocus)="onMobileFocus($event)"
                  [errorMessage]="{required:'Please enter number',custom:'Please enter a valid phone number'}"
                />
                <app-phone-number-input *ngIf="!showInputV2"
                  [control]="mobileControl"
                  [group]="userForm"
                  [placeHolder]="info.mobile.placeholder"
                  [showEdit]="showPhoneEdit"
                  [errorMessage]="info.mobile.error"
                  (numberEmit)="phoneNumber=$event"
                  (onIconClick)="editMobileClick($event)"
                />
              </div>
            </div>
            <div *ngIf="showOtp" class="field">
              <div class="otp">
                <app-otp-input
                  [control]="otpControl"
                  [group]="userForm"
                  (otpEmit)="otp=$event"
                  (onResendClick)="resendMobileOtp($event)"
                  [boxType]="showOtpSeparate"
                  [autoFillOtp]="autoFillOtp"
                  (onFocus)="onOTPFocus($event)"
                />
              </div>
            </div>
          </div>
          <div class="actBtn">
            <button *ngIf="isInline" type="submit" [disabled]="loading" mat-ripple>
              <div *ngIf="!loading" class="text"><span>{{showOtp ? btnLabel: 'Continue'}}</span><em *ngIf="!showOtp" class="material-icons">arrow_forward</em></div>
              <div *ngIf="loading" class="loader"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>
            </button>
            <app-basic-button *ngIf="!isInline" type="submit" [label]="btnLabel" [loading]="loading" [themeConfig]="{width: '100%', height: '38px', fontSize: '14px', letterSpacing: '-0.28px', borderSize: '0', bgColor: '#01BFBD', textColor: '#FCFCFC', boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.24)'}" postIcon="arrow_forward_ios"/>
          </div>
          <div *ngIf="isInline && showOtp" class="resendEdit">
            <div class="resend" (click)="resendMobileOtp($event)" mat-ripple>RESEND OTP</div><span></span><div class="edit" (click)="editMobileClick()" mat-ripple>EDIT NUMBER</div>
          </div>
        </form>
      </div>
      <div *ngIf="!isInline && !hideAgree" class="terms-n-policy"> By continuing you are agreeing to our
        <a rel="noopener" href="https://www.ketto.org/privacy-policy.php" target="_blank">Privacy Policy</a> and
        <a rel="noopener" href="https://www.ketto.org/terms-of-use.php" target="_blank">Terms of Service</a>
      </div>
      <div *ngIf="!isInline && !hideStartFund" class="startFund">Want to start a fundraiser?<a [routerLink]="'/new/crowdfunding'" (click)="closePopup()">Click here</a></div>
    </div>
  </div>
</ng-template>

<app-captcha />
<app-captcha-input #backendCaptcha [control]="captcha" [size]="'invisible'" [execute]="false" [type]="popupView ? (isMobile ? 'sheet' : 'dialog') : ''" (dataEmit)="onBackendCaptchaResolved($event)" />
